import React, { useState } from 'react';
import apiClient from '../utils/apiClient';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const ContactModal = ({ onClose, isDarkMode }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState(''); // 'idle', 'sending', 'success', 'error'

  const c = isDarkMode ? {
    card: 'bg-[#1C1C1C]',
    text: 'text-gray-100',
    secondaryText: 'text-gray-400',
    border: 'border-gray-700',
    input: 'bg-[#1C1C1C] border-gray-600 text-white focus:ring-gray-400 focus:border-gray-400',
    button: 'bg-gray-700 text-white hover:bg-gray-600',
  } : {
    card: 'bg-white',
    text: 'text-gray-900',
    secondaryText: 'text-gray-600',
    border: 'border-gray-300',
    input: 'bg-gray-50 border-gray-300 text-gray-900 focus:ring-black focus:border-black',
    button: 'bg-gray-200 text-gray-800 hover:bg-gray-300',
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      // Replace with your actual API endpoint for sending messages
      // This is a placeholder and won't work without a backend
      const response = await apiClient.post('https://step-in.onrender.com/api/jobxai-contacts/', { name, email, message });
      console.log('Message sent:', response.data);
      setStatus('success');
      // Clear form after successful submission
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Failed to send message:', error);
      setStatus('error');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[60] bg-black bg-opacity-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 50, opacity: 0 }}
        className={`${c.card} ${c.border} rounded-xl shadow-lg p-6 w-full max-w-md mx-auto relative`}
        onClick={e => e.stopPropagation()}
      >
        <button onClick={onClose} className="absolute top-3 right-3 text-2xl text-gray-400 hover:text-gray-600 transition-colors">
          <FaTimes />
        </button>
        <h2 className={`text-2xl font-bold mb-4 ${c.text}`}>Contact Us</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className={`block text-sm font-medium mb-1 ${c.text}`}>Name</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className={`w-full p-2 rounded-lg border focus:outline-none focus:ring-2 transition-all ${c.input}`}
              required
            />
          </div>
          <div>
            <label htmlFor="email" className={`block text-sm font-medium mb-1 ${c.text}`}>Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full p-2 rounded-lg border focus:outline-none focus:ring-2 transition-all ${c.input}`}
              required
            />
          </div>
          <div>
            <label htmlFor="message" className={`block text-sm font-medium mb-1 ${c.text}`}>Message</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="4"
              className={`w-full p-2 rounded-lg border focus:outline-none focus:ring-2 transition-all ${c.input}`}
              required
            />
          </div>
          <motion.button
            type="submit"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            disabled={status === 'sending'}
            className={`w-full px-4 py-2 rounded-lg font-semibold transition-all duration-200 ${c.button} ${status === 'sending' ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </motion.button>
          {status === 'success' && <p className="text-green-500 text-center mt-2">Message sent successfully!</p>}
          {status === 'error' && <p className="text-red-500 text-center mt-2">Failed to send message. Please try again.</p>}
        </form>
      </motion.div>
    </motion.div>
  );
};

export default ContactModal;